import React from 'react'
import styled from '@emotion/styled'
import {ThemeType} from 'types/Theme'

const ErrorBlockElement = styled.div`
  background: ${(p: {theme: ThemeType}) =>
    p.theme.colors.background.danger.c100};
  padding: ${(p: {theme: ThemeType}) => p.theme.layout.spacing.s600}px;
  margin: ${(p: {theme: ThemeType}) => p.theme.layout.spacing.s600}px;
  border-radius: 4px;
`

const ErrorBlockHeadingElement = styled.h2`
  color: ${p => p.theme.colors.content.danger.c700};
  font-size: ${p => p.theme.fonts.size.md};
  margin: 0 0 ${p => p.theme.fonts.size.sm};
`

const ErrorBlockDescriptionElement = styled.div`
  color: ${p => p.theme.colors.content.danger.c700};
  font-size: ${p => p.theme.fonts.size.sm};
  margin: 0;
`

const ErrorBlock = (
  props: React.PropsWithChildren<{heading: React.ReactNode}>
) => {
  const {heading} = props

  return (
    <ErrorBlockElement>
      <ErrorBlockHeadingElement>{heading}</ErrorBlockHeadingElement>
      <ErrorBlockDescriptionElement>
        {props.children}
      </ErrorBlockDescriptionElement>
    </ErrorBlockElement>
  )
}

export default ErrorBlock
